import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { setAxiosHeaderToken } from "./utility/axiosDefaults";
import { Provider } from "react-redux";

import store from "./store/index";
const app = (
	<Provider store={store}>
		<React.StrictMode>
			<App />
		</React.StrictMode>
	</Provider>
);

//set auth token for axios headers
setAxiosHeaderToken();

ReactDOM.render(app, document.getElementById("root"));
